import { Chart, ChartEditorOptions, ChartJsDataModel, MetricItem } from '../../domain/chart/ChartDomains';
import moment from 'moment';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { ChartActions } from '../actions/ChartActions';
import ChartValueFactory from '../../util/ChartValueFactory';
import { ChartType, TokenVariable } from '@trlogic/ui-pack';
import ChartUtil from '../../util/ChartUtil';

export interface ChartState {
  chartEditorOptions: ChartEditorOptions;
  chart: Chart;
  isUpdate: boolean;
  loading: true;
  expressionVariables: Record<string, TokenVariable[]>;
  chartResponse: ChartJsDataModel | undefined;
}

const initialState: ChartState = {
  chart: {
    id: '',
    name: '',
    description: null,
    dataSource: null,
    type: ChartType.LINE,
    createdDate: moment().date(),
    dashboardId: null,
    updatedDate: moment().date(),
    visualOptions: ChartUtil.getChartOptionsByChartType(ChartType.LINE, {
      name: 'Test Chart',
      metrics: [],
      legendDisplay: true,
    }),
    permission: 'No Permission',
    collaborators: [],
  } as Chart,
  chartEditorOptions: {
    transactionVariables: [],
    segmentEditorVisible: false,
    metricEditorVisible: false,
    globalFilterEditorVisible: false,
    breakdownEditorVisible: false,
    startDate: { value: moment().subtract(3, 'year').toDate(), type: 'Absolute', label: 'Last 3 Year' },
    endDate: { value: 'Now', type: 'Now', label: 'Now' },
    segmentItem: null,
    metricItem: [] as MetricItem[],
    globalFilterItem: null,
    breakdown: null,
    activeMetricItem: null,
  },
  isUpdate: false,
  loading: true,
  expressionVariables: {},
  chartResponse: undefined,
};

export const chartReducer = (state: ChartState = initialState, action: ReduxBaseAction<any, ChartActions>) => {
  switch (action.type) {
    case 'CHANGE_CHART':
      return { ...state, chart: action.payload };
    case 'CHANGE_CHART_EDITOR_OPTIONS':
      return { ...state, chartEditorOptions: action.payload };
    case 'CHANGE_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'SET_EXPRESSION_VARIABLES':
      return { ...state, expressionVariables: action.payload };
    case 'CLEAR_CHART':
      return {
        ...state,
        chart: ChartValueFactory.initializeChart(),
        chartEditorOptions: ChartValueFactory.initializeChartEditorOptions(),
        isUpdate: false,
        expressionVariables: {},
        loading: true,
        chartResponse: undefined,
      };
    case 'CHANGE_LOADING':
      return { ...state, loading: action.payload };
    case 'CHANGE_CHART_RESPONSE':
      return { ...state, chartResponse: action.payload };
    default:
      return state;
  }
};
